import script from "./ScoreResult.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreResult.vue?vue&type=script&setup=true&lang=js"

import "./ScoreResult.vue?vue&type=style&index=0&id=8052dd5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8052dd5c"]])

export default __exports__